export type CardOccasion = 
  | 'birthday'
  | 'anniversary'
  | 'thank-you'
  | 'graduation'
  | 'new-baby'
  | 'wedding'
  | 'appreciation'
  | 'congratulations'
  | 'promotion'
  | 'new-home'
  | 'bulk'
  | 'general';

export interface OccasionGuide {
  tone: string;
  guidelines: {
    structure: string;
    length: string;
    style: string;
    focus: string;
    avoid: string;
  };
}

export interface DefaultGuide {
  title: string;
  description: string;
  suggestions: never[];
}

export type OccasionGuideType = OccasionGuide | DefaultGuide;

export interface OccasionCategory {
  id: string;
  label: string;
  icon: string;
  description: string;
}

export const OCCASION_CATEGORIES: Record<string, OccasionCategory[]> = {
  'Celebrations': [
    { id: 'birthday', label: 'Birthday', icon: '🎂', description: 'Celebrate another year' },
    { id: 'anniversary', label: 'Anniversary', icon: '💑', description: 'Commemorate special dates' },
    { id: 'graduation', label: 'Graduation', icon: '🎓', description: 'Celebrate academic achievement' },
    { id: 'wedding', label: 'Wedding', icon: '💍', description: 'Celebrate marriage' },
    { id: 'new-baby', label: 'New Baby', icon: '👶', description: 'Welcome a new arrival' }
  ],
  'Gratitude': [
    { id: 'thank-you', label: 'Thank You', icon: '🙏', description: 'Express gratitude' },
    { id: 'appreciation', label: 'Appreciation', icon: '❤️', description: 'Show appreciation' }
  ],
  'Special Events': [
    { id: 'congratulations', label: 'Congratulations', icon: '🎉', description: 'Celebrate achievements' },
    { id: 'promotion', label: 'Job Promotion', icon: '💼', description: 'Celebrate career growth' },
    { id: 'new-home', label: 'New Home', icon: '🏠', description: 'Celebrate a new home' }
  ]
};

export function validateOccasion(occasion: string): asserts occasion is CardOccasion {
  if (!Object.values(OCCASION_CATEGORIES)
    .flat()
    .some(cat => cat.id === occasion)) {
    throw new Error(`Invalid occasion type: ${occasion}`);
  }
} 